var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mheader'),_c('div',{staticStyle:{"margin-top":"3rem"}},[_c('p',[_vm._v(_vm._s(_vm.$t('i.index_welcome')))]),_c('p',[_vm._v(_vm._s(_vm.$t('i.index_introduce')))]),_c('p',[_c('router-link',{attrs:{"to":"/article"}},[_vm._v("[Article List]")])],1),_c('p',[_vm._v("Thanks for your attention.")])]),_c('mfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }